module.exports = __webpack_public_path__ + "static/13-advanced-ddos-protection-64d315e7d7657ef59b8ca6a5e9ac331c.jpg";